export default __webpack_public_path__ + "images/GoGetter.v-cfaee406188ba166054deb5ad6639cce.svg";